<template>
  <card class="card" title="Cadastrar Novo Combo">
    <form @submit.prevent="createCombo">
      <div class="row">
        <div class="col-md-3">
          <fg-input
            type="text"
            label="Digite o nome do combo"
            v-model="combo.name"
            required
          ></fg-input>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="exampleFormControlTextarea1"
              >Selecione o plano de Internet do combo</label
            >
            <select
              class="form-control input i-width"
              v-model="combo.internetPlanId"
              required
            >
              <option :value="null" selected disabled>Selecione...</option>
              <option
                v-for="plan in internetPlans"
                :value="plan.planId"
                :key="plan.id"
              >
                {{ plan.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="exampleFormControlTextarea1"
              >Selecione o plano de TV do combo</label
            >
            <select class="form-control input i-width" v-model="combo.tvPlanId">
              <option :value="null" selected disabled>Selecione...</option>
              <option
                v-for="plan in tvPlans"
                :value="plan.planId"
                :key="plan.id"
              >
                {{ plan.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="exampleFormControlTextarea1"
              >Selecione o plano de Telefone do combo</label
            >
            <select
              class="form-control input i-width"
              v-model="combo.phonePlanId"
            >
              <option :value="null" selected disabled>Selecione...</option>
              <option
                v-for="plan in phonePlans"
                :value="plan.planId"
                :key="plan.id"
              >
                {{ plan.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="container_buttons">
        <button class="btn-custom btn-salvar">Criar Combo</button>
      </div>
    </form>
    <hr />

    <span class="d-block mt-3">Pré-visualização do combo</span>
    <CardPlan
      :name="combo.name"
      :internet-plan="internetPlan"
      :tv-plan="tvPlan"
      :phone-plan="phonePlan"
    />
  </card>
</template>

<script>
import { mapActions } from "vuex";
import Swal from "sweetalert2";

import CardPlan from "../../components/Plans/CardPlan.vue";

export default {
  components: {
    CardPlan,
  },
  computed: {
    plans() {
      return this.$store.getters.plans;
    },
    internetPlans() {
      return this.plans.filter((plan) => [27, 33].includes(plan.groupId));
    },
    tvPlans() {
      return this.plans.filter((plan) => [29].includes(plan.groupId));
    },
    phonePlans() {
      return this.plans.filter((plan) => [30].includes(plan.groupId));
    },
    internetPlan() {
      return this.internetPlans.find(
        (p) => p.planId === this.combo.internetPlanId
      );
    },
    tvPlan() {
      return this.tvPlans.find((p) => p.planId === this.combo.tvPlanId);
    },
    phonePlan() {
      return this.phonePlans.find((p) => p.planId === this.combo.phonePlanId);
    },
  },
  methods: {
    ...mapActions(["fetchPlans", "addCombo"]),
    async createCombo() {
      try {
        await this.addCombo({ body: this.combo });
        await Swal.fire({
          icon: "success",
          title: "Sucesso!",
          text: "Combo cadastrado com sucesso!",
        });
        this.$router.push("/combos");
      } catch (err) {
        await Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Erro ao cadastrar o combo",
        });
      }
    },
  },
  data() {
    return {
      combo: {
        name: '',
        internetPlanId: null,
        tvPlanId: null,
        phonePlanId: null,
      },
    };
  },
  async mounted() {
    try {
      await this.fetchPlans();
    } catch (err) {
      await Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Erro ao carregar os planos",
      });
    }
  },
};
</script>

<style lang="scss" scoped>
span {
  font-size: 20px;
  font-weight: bold;
}
.btn-custom {
  color: #f4f3ef;
  border: none;
  border-radius: 7px;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 13px 20px;
  transition: all 0.5s;

  &.btn-salvar {
    background: #9dcf6b;
    padding: 13px 25px;
    &:hover {
      background: #82ac58;
    }
  }

  &.btn-analise {
    margin-left: 10px;
    background: orange;
    &:hover {
      background: #c07e03;
    }
  }

  &.btn-interesse {
    margin-left: 10px;
    background: #b80a0a;
    &:hover {
      background: #700202;
    }
  }
}
</style>
